/* The Pampered Petal — signature footer behaviour
   Custom element: auto-initialises on page load AND in the Shopify theme editor. */
(() => {
  if (customElements.get('pp-petal-footer')) return;

  const DESKTOP = window.matchMedia('(min-width: 750px)');
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  const HEART = '<svg viewBox="0 0 24 22" aria-hidden="true"><path d="M12 21.5S1.5 14.8 1.5 7.4A5.6 5.6 0 0 1 12 4.6a5.6 5.6 0 0 1 10.5 2.8C22.5 14.8 12 21.5 12 21.5Z"/></svg>';

  class PPPetalFooter extends HTMLElement {
    connectedCallback() {
      this.cols = Array.from(this.querySelectorAll('.ppf__col'));
      this.onMq = () => this.syncAccordions();
      this.onSummary = (e) => this.handleSummary(e);

      this.cols.forEach((col) => col.querySelector('summary').addEventListener('click', this.onSummary));
      DESKTOP.addEventListener ? DESKTOP.addEventListener('change', this.onMq) : DESKTOP.addListener(this.onMq);
      this.syncAccordions(true);

      this.setupReveal();
      this.setupHearts();

      const top = this.querySelector('[data-ppf-top]');
      if (top) top.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: REDUCED.matches ? 'auto' : 'smooth' });
        const skip = document.querySelector('#MainContent, main, [role="main"]');
        if (skip) { skip.setAttribute('tabindex', '-1'); skip.focus({ preventScroll: true }); }
      });
    }

    disconnectedCallback() {
      DESKTOP.removeEventListener ? DESKTOP.removeEventListener('change', this.onMq) : DESKTOP.removeListener(this.onMq);
      if (this.io) this.io.disconnect();
    }

    /* ---- Accordions: open + locked on tablet/desktop, collapsible on mobile ---- */
    syncAccordions(initial) {
      const desktop = DESKTOP.matches;
      this.cols.forEach((col) => {
        const summary = col.querySelector('summary');
        if (desktop) {
          col.open = true;
          summary.setAttribute('tabindex', '-1');
          summary.removeAttribute('aria-expanded');
        } else {
          if (initial || !col.dataset.userOpen) col.open = false;
          summary.removeAttribute('tabindex');
          summary.setAttribute('aria-expanded', String(col.open));
        }
      });
    }

    handleSummary(e) {
      const col = e.currentTarget.parentElement;
      e.preventDefault();
      if (DESKTOP.matches) return;
      const panel = col.querySelector('.ppf__panel');
      const summary = e.currentTarget;
      const opening = !col.open;
      col.dataset.userOpen = opening ? '1' : '';
      summary.setAttribute('aria-expanded', String(opening));

      if (REDUCED.matches || !panel.animate) { col.open = opening; return; }
      if (this._anim && this._anim.panel === panel) this._anim.cancel();

      if (opening) {
        col.open = true;
        const h = panel.scrollHeight;
        const a = panel.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.22,1,.36,1)' });
        a.panel = panel; this._anim = a;
      } else {
        const h = panel.scrollHeight;
        const a = panel.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.4,0,.2,1)' });
        a.panel = panel; this._anim = a;
        a.onfinish = () => { col.open = false; };
      }
    }

    /* ---- Reveal on scroll ---- */
    setupReveal() {
      if (!this.classList.contains('ppf--animate') || REDUCED.matches || !('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) {
        this.classList.add('is-in');
        return;
      }
      const rect = this.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) { this.classList.add('is-in'); return; }
      this.classList.add('ppf--ready');
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { this.classList.add('is-in'); this.io.disconnect(); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      this.io.observe(this);
    }

    /* ---- A little love: hearts float up from the pets ---- */
    setupHearts() {
      const pets = this.querySelector('[data-ppf-pets]');
      if (!pets) return;
      const layer = pets.querySelector('.ppf__hearts');
      let last = 0;
      const burst = (x, y, count) => {
        if (REDUCED.matches) return;
        for (let i = 0; i < count; i++) {
          const h = document.createElement('span');
          h.className = 'ppf__heart';
          h.innerHTML = HEART;
          h.style.left = x + (Math.random() * 40 - 20) + 'px';
          h.style.top = y + (Math.random() * 20 - 10) + 'px';
          h.style.setProperty('--dx', (Math.random() * 60 - 30).toFixed(0) + 'px');
          h.style.setProperty('--r', (Math.random() * 30 - 15).toFixed(0) + 'deg');
          h.style.animationDelay = i * 90 + 'ms';
          h.style.width = h.style.height = (1.4 + Math.random() * 1.2).toFixed(2) + 'rem';
          layer.appendChild(h);
          h.addEventListener('animationend', () => h.remove());
        }
      };
      const local = (e) => {
        const r = pets.getBoundingClientRect();
        return [e.clientX - r.left, e.clientY - r.top];
      };
      pets.addEventListener('click', (e) => { const [x, y] = local(e); burst(x, y, 5); });
      pets.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        const now = performance.now();
        if (now - last < 650) return;
        last = now;
        const [x, y] = local(e);
        burst(x, y, 1);
      });
    }
  }

  customElements.define('pp-petal-footer', PPPetalFooter);
})();
